<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Available Orders</h1>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m">
              <input type="text" name="search" [(ngModel)]="searchParams.order_id" (change)="rerender()" placeholder="Search by Order ID">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}" >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#1C212D"/>
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D"/>
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D"/>
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D"/>
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D"/>
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D"/>
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D"/>
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D"/>
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D"/>
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D"/>
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D"/>
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D"/>
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D"/>
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D"/>
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Order ID</th>
              <th>Client Name</th>
              <th>Academic Level</th>
              <th>Document Type</th>
              <th>Title</th>
              <th>Pages</th>
              <th>Citation</th>
              <th>Sources</th>
              <th class="forWriters">Compensation</th>
              <th>Due Date</th>
              <th class="forWM">Writer Remaining Time</th>
              <th class="forWM">Assigned To</th>
              <th class="forWriters">Status</th>
            </tr>
          </thead>

          <!-- For Writers -->
          <ng-container *ngIf="activeUser.Portal_Writer && leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td class="sr-no">{{ paginatePage + (indx + 1) }}</td>
                <td class="id">
                  <a class="withIcon" href="javascript:;" routerLink="/order-detail/{{ lead.id | base64 }}" target="_blank">
                      {{ lead.order_id }}
                      <span class="searchIcon">
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.43066 8.82471C4.16116 8.82471 3.94238 9.04329 3.94238 9.3128C3.94238 9.58231 4.16116 9.80108 4.43066 9.80108C4.70017 9.80108 4.91895 9.58231 4.91895 9.3128C4.91895 9.04329 4.70017 8.82471 4.43066 8.82471Z" fill="#00A5DC"/>
                            <path d="M18.1114 14.6591C18.02 14.5675 17.8956 14.516 17.7661 14.516C17.7612 14.517 17.5735 14.5065 17.4209 14.6591L17.0759 15.0041L15.954 13.8824C18.4297 10.412 18.0532 5.62471 15.0043 2.576C11.5699 -0.858379 6.01075 -0.858951 2.576 2.576C-0.858379 6.01018 -0.858951 11.5695 2.576 15.0043C5.61727 18.0458 10.4026 18.436 13.8822 15.954L15.0041 17.0759L14.6591 17.4209C14.4685 17.6115 14.4683 17.9208 14.6591 18.1116L20.832 24.2839C21.7859 25.2384 23.3299 25.2389 24.2839 24.2841C25.2384 23.3305 25.2388 21.7863 24.2839 20.8322L18.1114 14.6591ZM15.6946 16.3854L14.6491 15.34C14.7706 15.2311 14.8895 15.1193 15.0043 15.0043C15.1193 14.8895 15.2311 14.7706 15.34 14.6493L16.3854 15.6948L15.6946 16.3854ZM3.26646 14.3138C0.213552 11.2611 0.21317 6.31955 3.26646 3.26646C6.31917 0.213552 11.2607 0.21317 14.3138 3.26646C17.3599 6.3123 17.3753 11.2527 14.3138 14.3138C11.2178 17.4102 6.27759 17.3252 3.26646 14.3138ZM17.7661 15.6948L19.1469 17.0757L17.0757 19.1469L15.6948 17.7661L17.7661 15.6948ZM23.5935 23.5937C23.0213 24.1664 22.0952 24.1666 21.5227 23.5937L17.7661 19.8373L19.8373 17.7661L23.5937 21.5229C24.1663 22.0949 24.1668 23.0209 23.5935 23.5937Z" fill="#00A5DC"/>
                            <path d="M13.6235 3.9573C10.9534 1.2872 6.62768 1.28567 3.95643 3.95691C1.29187 6.62206 1.29187 10.9586 3.95643 13.6239C6.62806 16.2954 10.9513 16.2956 13.6231 13.6239C16.2882 10.9586 16.2884 6.62225 13.6235 3.9573ZM12.9326 12.9333C10.6428 15.2231 6.93724 15.2236 4.6469 12.9335C2.36303 10.6489 2.36303 6.93181 4.6469 4.64719C6.93552 2.35875 10.6436 2.35817 12.933 4.64776C15.2172 6.932 15.2171 10.6489 12.9326 12.9333Z" fill="#00A5DC"/>
                            <path d="M8.79013 3.9082C7.48512 3.9082 6.25908 4.41594 5.33783 5.33776C4.80377 5.87182 4.41066 6.50277 4.16957 7.21345C4.08298 7.46865 4.21955 7.74598 4.47494 7.83258C4.73072 7.91936 5.00766 7.78203 5.09426 7.52721C5.28671 6.95977 5.60104 6.45547 6.02829 6.02803C6.76529 5.29084 7.74605 4.88477 8.79013 4.88477C9.05983 4.88477 9.27841 4.66618 9.27841 4.39648C9.27841 4.12679 9.05983 3.9082 8.79013 3.9082Z" fill="#00A5DC"/>
                            </svg>
                      </span>
                  </a>
                </td>
                <td class="forWriters">
                    <p>{{ lead.cust_name }}</p>
                </td>
                <td class="forWriters">
                    <p>{{ lead.acdLevel | capitalize }}</p>
                </td>
                <td class="forWriters">
                    <p class="time-done" [innerHtml]="lead.doc_Type | safeHtml:'html' "></p>
                </td>
                <td class="forWriters">
                    <p class="time-done" [title]="lead.subject | capitalize">{{ lead.subject | capitalize }}</p>
                    <p class="time-done" [title]="lead.title | capitalize">{{ lead.title   | capitalize }}</p>
                </td>
                <td>
                  <p class="page-td time-done">{{ lead.pages }}</p>
                </td>
                <td class="forWriters">
                    <p>{{ lead.citation }}</p>
                </td>
                <td class="forWriters">
                    <p class="time-done" [title]="lead.sources | capitalize">{{ lead.sources }}</p>
                </td>
                <td class="forWriters" *ngIf="activeUser.is_writer">
                    <p>{{ lead.compensation }}</p>
                </td>
                <td class="forWriters">
                    <p *ngIf="lead.delivery_date">{{ lead.delivery_date | date }}</p>
                    <p>{{ lead.delivery_date | date:'shortTime' }}</p>

                    <!-- Only for Writer -->
                    <p class="time-left" *ngIf="activeUser.is_writer" [ngClass]="{'time-left': !lead.invert, 'time-elapsed': lead.invert}">{{ lead.due_date }}</p>
                </td>
                <td class="forWritersManager" *ngIf="activeUser.is_writermanager">
                    <p class="time-left" [ngClass]="{'time-left': !lead.invert, 'time-elapsed': lead.invert}">{{ lead.due_date }}</p>
                </td>
                <td class="forWritersManager" *ngIf="activeUser.is_writermanager">
                  <div class="pos-rel">
                    <div class="fields-m assigned-field select-m mx-auto" style="float: none;" *ngIf="!lead.loading">
                        <ng-select
                          [items]="writers"
                          placeholder="Assign Writer"
                          [(ngModel)]="lead.agent_id"
                          [ngModelOptions]="{standalone: true}"
                          [searchable]="true"
                          [clearable]="false"
                          bindLabel= "name"
                          bindValue = "id"
                          (change)= "openAssignTo_Writer_byManager_Modal(indx)"
                        >
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          {{ item.name }}
                        </ng-template>
                      </ng-select>
                    </div>

                    <!-- Loader -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.loading"></i>

                    <!-- Assign To Writer by Manger Model -->
                    <div class="paid-modal-m deleteModal">
                      <div class="modal fade" [id]="'writer_assign_by_manager_modal' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">Are you sure you want to assign this Order?</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a href="javascript:;" (click)="revertAssignByManager(indx)">NO</a>
                                <a href="javascript:;" class="yes-btn bgBlue" (click)="assignTo_Writer_byManager(indx)">YES</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="forWriters" *ngIf="activeUser.is_writer">
                  <div class="pos-rel">
                    <p class="roundedShape" *ngIf="lead.status == 'Not Available'">
                        <span class="invalidBox">Not Available</span>
                    </p>

                    <div class="fields-m disposition-open select-m" *ngIf="lead.status == 'Available'">
                    <!-- <div class="fields-m disposition-open select-m" > -->
                        <ng-select
                            [items]="writersAction"
                            placeholder="Available"
                            [(ngModel)]="lead.action"
                            [ngModelOptions]="{standalone: true}"
                            [searchable]="true"
                            [clearable]="false"
                            (change)= "openAssignToMe_Writer_Modal(indx)"
                            *ngIf="!lead.loading"
                        >
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          {{ item }}
                        </ng-template>
                      </ng-select>
                    </div>

                    <!-- Action Loader -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.loading"></i>

                    <!-- Writer Assign Me Model -->
                    <div class="paid-modal-m deleteModal">
                      <div class="modal fade" [id]="'writer_assignme_modal' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">Are you sure you want to assign this Order?</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
                                <a href="javascript:;" class="yes-btn bgBlue" (click)="assignToMe_Writer()">YES</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
            </tr>
          </tbody>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- floating alert starts -->
<ng-container *ngIf="leads.alertMessage && leads.data && leads.data.length > 0">
    <div class="floatingAlert" *ngIf="floatingAlert">
        <button type="button" class="close" (click)="closeFloatingAlert();">
          <i class="fa fa-times"></i>
        </button>
        <p>{{ leads.alertMessage }}</p>
    </div>
</ng-container>

<!-- floating alert ends -->
